import { render } from "./ConfigForm.vue?vue&type=template&id=b9a3a240&scoped=true"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"

import "./ConfigForm.vue?vue&type=style&index=0&id=b9a3a240&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a3a240"]])

export default __exports__